import Nav from "./nav"
import Sliders from "./sliders"
import Timeline from "./timeline"

document.addEventListener("DOMContentLoaded", function () {
    Nav(jQuery)
    Sliders(jQuery)
    Timeline(jQuery)
})
